import React, { useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useNavigationBar } from "../../../context/NavigationContext";
import * as Yup from "yup";
import ChannelCheckListCard from "./components/ChannelCheckListCard";
import {
  ActionItem,
  ActionOnItem,
  ChannelState,
  ChannelSubstate,
  ChannelType,
  getCreatorActionableItems,
  SKChannel,
  Tier,
} from "../../../models/SKChannel";
import { capitalizeFirstLetter, pluralize } from "../../../utils/stringFunctions";
import { AddTextAreaField } from "../../../components/AddTextAreaField";
import { useAuth, UserRole } from "../../../context/AuthContext";
import ImageInput from "../../artifacts/create/ImageInput";
import { FolderName } from "../../../api/shared/uploadService";
import { iso6392 } from "iso-639-2";
import { iso31661 } from "iso-3166";
import { CreateChannelContext } from "../../../context/CreateChannelContext";
import { deleteChannel, updateChannel } from "../../../api/channels/channelServices";
import LoadingPopup from "./LoadingPopup";
import { SKSelectOption } from "../../../components/SKSelectOption";
import { AddTextField } from "../../../components/AddTextField";
import HistoryNavigator from "./components/HistoryNavigator";
//import ArtifactStateDialog, { DialoageContent } from "../../contentModeration/ArtifactStateDialog-Old";
import ArtifactStateDialog, { DialoageContent } from "../../artifacts/create/container/components/ArtifactStateDialog";
import ArtifactModerationDialog from "../../contentModeration/ArtifactModerationDialog";
import ChannelEditNavigator from "../../channelManagement/ChannelEditNavigator";
import PopupSingleButton, { PopupActionStatus } from "../../../components/PopupSingleButton";
import { set } from "date-fns";
import { useLeftbarBar } from "../../../context/LeftSidebarContext";
import { TopicTypeString } from "../../../models/SKArtifact";
import { ContentAgeRestriction } from "../../../api/enums";
import { ChannelPublishingTier } from "./ChannelPublishingTier";
import APILoader from "../../../components/APILoader";
import OptionSelect from "../../../components/OptionSelect";
import { ChannelSubscriptionType } from "./ChannelSubscriptionType";
import { PrimaryExternalLinkData } from "../../../utils";

interface ChannelViewProps {
  isModal?: boolean;
}
export default function ChannelView({ isModal = false }: ChannelViewProps) {
  const List_of_languages_to_be_displayed = [
    "Afrikaans",
    "Akan",
    "Albanian",
    "Amharic",
    "Arabic",
    "Armenian",
    "Assamese",
    "Aymara",
    "Azerbaijani",
    "Bashkir",
    "Basque",
    "Belarusian",
    "Bengali",
    "Bhojpuri",
    "Bosnian",
    "Breton",
    "Bulgarian",
    "Burmese",
    "Catalan",
    "Cebuano",
    "Chamorro",
    "Chichewa",
    "Chinese (Simplified)",
    "Chinese (Traditional)",
    "Chuvash",
    "Corsican",
    "Cree",
    "Croatian",
    "Czech",
    "Danish",
    "Dari",
    "Divehi",
    "Dogri",
    "Dutch",
    "Dzongkha",
    "English",
    "Esperanto",
    "Estonian",
    "Ewe",
    "Fijian",
    "Filipino (Tagalog)",
    "Finnish",
    "Flemish",
    "French",
    "Frisian",
    "Fulah",
    "Galician",
    "Georgian",
    "German",
    "Greek",
    "Guarani",
    "Gujarati",
    "Haitian Creole",
    "Hausa",
    "Hawaiian",
    "Hebrew",
    "Hindi",
    "Hmong",
    "Hungarian",
    "Icelandic",
    "Igbo",
    "Ilocano",
    "Indonesian",
    "Inuktitut",
    "Irish",
    "Italian",
    "Japanese",
    "Javanese",
    "Kannada",
    "Kazakh",
    "Khmer",
    "Kinyarwanda",
    "Kirghiz",
    "Konkani",
    "Korean",
    "Kurdish",
    "Lao",
    "Latin",
    "Latvian",
    "Lingala",
    "Lithuanian",
    "Luxembourgish",
    "Macedonian",
    "Malagasy",
    "Malay",
    "Malayalam",
    "Maltese",
    "Maori",
    "Marathi",
    "Mongolian",
    "Manipuri",
    "Nepali",
    "Norwegian",
    "Nyanja",
    "Odia (Oriya)",
    "Ojibwe",
    "Pashto",
    "Persian (Farsi)",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Quechua",
    "Romanian",
    "Romansh",
    "Russian",
    "Samoan",
    "Sanskrit",
    "Scots Gaelic",
    "Serbian",
    "Sesotho",
    "Shona",
    "Sindhi",
    "Sinhala",
    "Slovak",
    "Slovenian",
    "Somali",
    "Spanish",
    "Sundanese",
    "Swahili",
    "Swedish",
    "Tahitian",
    "Tajik",
    "Tamil",
    "Tatar",
    "Telugu",
    "Thai",
    "Tibetan",
    "Tigrinya",
    "Tok Pisin",
    "Tswana",
    "Turkish",
    "Turkmen",
    "Ukrainian",
    "Urdu",
    "Uyghur",
    "Uzbek",
    "Vietnamese",
    "Volapük",
    "Walloon",
    "Welsh",
    "Wolof",
    "Xhosa",
    "Yiddish",
    "Yoruba",
    "Zulu",
  ];

  const List_of_countries_to_be_displayed = [
    "Albania",
    "Algeria",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Belgium",
    "Benin",
    "Bhutan",
    "BoliBolivia (Plurinational State of)via",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brunei Darussalam",
    "Bulgaria",
    "Cambodia",
    "Canada",
    "Chile",
    "Colombia",
    "Costa Rica",
    "Côte d’Ivoire",
    "Croatia",
    "Cyprus",
    "Czechia",
    "Denmark",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Estonia",
    "Ethiopia",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Germany",
    "Ghana",
    "Greece",
    "Guatemala",
    "Guyana",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kuwait",
    "Lao People's Democratic Republic",
    "Latvia",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malaysia",
    "Malta",
    "Mauritius",
    "Mexico",
    "Republic of Moldova",
    "Monaco",
    "Mongolia",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Netherlands",
    "New Zealand",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Panama",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Rwanda",
    "San Marino",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "South Africa",
    "Korea (Republic of)",
    "Spain",
    "Sri Lanka",
    "Saint Lucia",
    "Sweden",
    "Switzerland",
    "Taiwan (Province of China)",
    "Tanzania (United Republic of)",
    "Thailand",
    "Trinidad and Tobago",
    "Tunisia",
    "Türkiye",
    "United Arab Emirates",
    "United Kingdom of Great Britain and Northern Ireland",
    "Uruguay",
    "Uzbekistan",
    "Viet Nam",
    "Bolivia",
    "Côte d’Ivoire",
    "Moldova",
    "Netherlands",
    "South Korea",
    "Taiwan",
    "Tanzania",
  ];

  const sortedExternalLinkOptions = PrimaryExternalLinkData.map(link => ({
    title: link.title,
    value: link.type,
  }));

  let maxFileSizeMB = 2;
  let allowedTypes = ["image/jpeg", "image/png"];
  const [id, setId] = useState<string>();
  const [uploadingProfile, setUploadingProfile] = useState(false);
  const [uploadingBack, setUploadingBack] = useState(false);
  const location = useLocation();
  const { state } = location;
  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});
  const authContext = useAuth();
  const [inputFocused, setInputFocused] = useState<{ [key: string]: boolean }>({});

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [actionOnItem, setActionOnItem] = useState<ActionOnItem | null>(null);
  const [dialogContent, setDialogContent] = useState<DialoageContent | null>(null);
  const moderationDialogActions = [ActionItem.reject, ActionItem.delete, ActionItem.withdraw, ActionItem.deactive];

  const [isValidForm, setIsValidForm] = useState(false);
  useEffect(() => {}, []);
  const navigate = useNavigate();

  const { setShowLeftbar } = useLeftbarBar();
  const { channelData, updateChannelData, updateDataOnServer, updateStatus, originalState, loading } = useContext(CreateChannelContext);

  useEffect(() => {
    if (authContext && authContext.userRoles && authContext.userRoles.length > 0 && updateChannelData) {
      const channelType = authContext?.userRoles?.includes(UserRole.BrandAdmin) ? ChannelType.brand : ChannelType.creator;
      updateChannelData(prev => {
        if (prev.status === ChannelState.DRAFT) {
          return { ...prev, channelType };
        } else {
          return { ...prev };
        }
      });
    }
  }, [authContext, updateChannelData]);

  // const externalLinkSchema = Yup.object().shape({
  //   primaryExternalLink: Yup.string().required(),
  //   secondoryExternalLink: Yup.string().notRequired(),
  //   otherExternalLink: Yup.string().notRequired(),
  // });
  // const [touched, setTouched] = useState({});
  const [touched, setTouched] = useState<Partial<Record<keyof SKChannel, boolean>>>({});

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setTouched(prev => ({ ...prev, [name]: true }));
    // Validate the field
    validateField(name, value);
  };

  const validateField = async (name: string, value: string) => {
    try {
      await schema.validateAt(name, { [name]: value });
      setErrors(prev => ({ ...prev, [name]: undefined })); // Remove error if valid
    } catch (error) {
      let err = error as Yup.ValidationError;
      setErrors(prev => ({ ...prev, [name]: err.message }));
    }
  };

  const validateForm = async (name: string, value: any) => {
    try {
      await schema.validateAt(name, { [name]: value });
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return true;
    } catch (err) {
      let error = err as Yup.ValidationError;
      if (inputFocused[name]) return false;
      setErrors(prev => ({ ...prev, [name]: error.message }));
      return false;
    }
  };

  const schema = Yup.object().shape({
    name: Yup.string().required(),
    description: Yup.string().required(),
    profileImageUrl: Yup.string().required(),
    backgroundImageUrl: Yup.string().required(),
    language: Yup.string().required().min(1),
    country: Yup.string().required(),
    topic: Yup.string().required(),
    age: Yup.string().required().min(1),
    certifyFirst: Yup.boolean().oneOf([true], "").required(),
    certifySecond: Yup.boolean().oneOf([true], "").required(),
    autoPublish: Yup.boolean().required(),
    externalLinks: Yup.array()
      .of(
        Yup.object().shape({
          type: Yup.string().required(),
          value: Yup.string().notRequired(),
        })
      )
      .min(1, "At least one url is required")
      .required(),

    subscriptionStatus: Yup.mixed<Tier>().notRequired(),

    expectedMonthlySubscriptionPrice: Yup.string().when("subscriptionStatus", {
      is: (val: Tier) => val === Tier.paid || val === Tier.freeNpaid,
      then: schema => schema.required("Monthly Subscription price is required when subscriptionStatus is true."),
      otherwise: schema => schema.nullable(),
    }),
    expectedYearlySubscriptionPrice: Yup.string().when("subscriptionStatus", {
      is: (val: Tier) => val === Tier.paid || val === Tier.freeNpaid,
      then: schema => schema.required("Yearly Subscription price is required when subscriptionStatus is true."),
      otherwise: schema => schema.nullable(),
    }),

    // subscriptionImageUrl: Yup.string().when("subscriptionStatus", {
    //   is: "channelSubscription",
    //   then: schema => schema.required("subscriptionImageUrl is required when subscriptionStatus is true."),
    //   otherwise: schema => schema.nullable(),
    // }),
    // subscriptionVideoUrl: Yup.string().url("subscriptionVideoUrl must be a valid URL.").nullable(),
  });

  const { setNavProps, showChildRouteAsModal, backgroundLocation, currentLocation } = useNavigationBar();

  const setNavbarProps = useCallback(() => {
    const updateChannels = async () => {
      setIsLoading(true);
      setIsError(false);
      try {
        if (channelData.status === ChannelState.DRAFT) {
          setIsSubmitted(true);
          channelData.id && updateStatus && (await updateStatus(channelData.id, ActionItem.submit_for_review));
        }

        //setIsLoading(false);
      } catch (error) {
        console.error("Error during submission:", error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    setNavProps({
      backArrow: false,
      title: "Channel",
      subtitle:
        channelData.status === ChannelState.DRAFT
          ? "Creator Channel"
          : channelData.status === ChannelState.ACTIVE
          ? ""
          : authContext?.currentUser?.displayName ?? "",
      // subtitle: contentData.status === ContentState.ACTIVE ? "" : capitalizeFirstLetter(contentData.type ?? ""),
      userActions: channelData.status === ChannelState.ACTIVE ? `${pluralize(channelData.followerCount ?? 0, "Follower")}` : "",
      buttonTitle: "Submit",
      filterOption: false,
      getActionItems: getPopItemsForId().length > 0 ? getPopItemsForId : undefined,
      enableLink: channelData.status === ChannelState.IN_REVIEW ? false : channelData.status === ChannelState.ACTIVE ? true : isValidForm,
      onActionItemSelect: actionItem => {
        setActionOnItem({
          itemid: channelData.id!,
          action: actionItem as ActionItem,
        });
      },
      // enableLink: channelData.status === ChannelState.IN_REVIEW ? false : isValidForm,
      onBack: () => {
        navigate("../onboarding");
      },
      onNext: channelData.status === ChannelState.DRAFT ? updateChannels : undefined,
      onEdit: channelData.status === ChannelState.ACTIVE ? requestEdit : undefined,
      onClose:
        channelData.status === ChannelState.DRAFT && channelData.subStatus === ChannelSubstate.NONE
          ? async () => {
              // isEdit && updateDataOnServer && (await updateDataOnServer());
              // !isEdit && navigate("../../../home");
              navigate(-1);
            }
          : undefined,
    });
  }, [channelData, isValidForm, setNavProps, navigate]);

  useEffect(() => {
    if (isModal) {
      showChildRouteAsModal(true);
    }
    return () => {
      if (isModal) {
        showChildRouteAsModal(false);
      }
    };
  }, []);

  // useEffect(() => {
  //   if (!channelData.id) {
  //     updateDataOnServer && updateDataOnServer();
  //   }
  // }, [updateDataOnServer, channelData]);

  useEffect(() => {
    !backgroundLocation?.pathname && setNavbarProps();
    currentLocation.pathname === backgroundLocation?.pathname && setNavbarProps();
  }, [setNavbarProps, currentLocation.pathname, backgroundLocation?.pathname]);

  useEffect(() => {
    if (actionOnItem?.action) {
      const contentDialog = getModerationDialogContent(actionOnItem.action);
      setDialogContent(contentDialog);
    }
  }, [actionOnItem]);

  function getModerationDialogContent(action: ActionItem): DialoageContent | null {
    switch (action) {
      case ActionItem.delete:
        return {
          message: "Are you sure you will like to Delete Channel?",
          description: "Permanently delete this channel. This action cannot be undone.",
          actionTitle: ActionItem.delete,
          destructiv: true,
        };
      case ActionItem.reject:
        return {
          message: "Are you sure you will like to Reject Channel?",
          description: "This channel will not be published to the users.",
          actionTitle: ActionItem.reject,
          destructiv: true,
        };

      case ActionItem.deactive:
        return {
          message: "Are you sure you will like to Deactivate Channel?",
          description: "Users will not be able to view this channel anymore.",
          actionTitle: ActionItem.deactive,
          destructiv: true,
        };
      case ActionItem.withdraw:
        return {
          message: "Are you sure you will like to Withdraw Channel?",
          description: "Users will not be able to view this channel anymore.",
          actionTitle: ActionItem.withdraw,
          destructiv: true,
        };
      case ActionItem.reject_edit:
        return {
          message: "Are you sure you will like to Reject Edits?",
          description: "Channel edits will be discarded. This action cannot be undone.",
          actionTitle: ActionItem.reject_edit,
          destructiv: true,
        };
      case ActionItem.approve:
        return {
          message: "Are you sure you will like to Approve Channel?",
          description: "This will publish the channel and make it visible to the users.",
          actionTitle: ActionItem.approve,
          destructiv: false,
        };
      case ActionItem.approve_edit:
        return {
          message: " Are you sure you will like to Approve Channel edits?",
          description: "Edits will be immediatly available to the public.",
          actionTitle: ActionItem.approve_edit,
          destructiv: false,
        };

      default:
        return null;
    }
  }

  const getPopItemsForId = (): ActionItem[] => {
    if (channelData) {
      const { status, subStatus } = channelData;
      return getCreatorActionableItems({ state: status, subState: subStatus });
    }
    return [];
  };

  useEffect(() => {
    setNavbarProps();
  }, [setNavbarProps]);

  const requestEdit = async () => {
    navigate("editChannel");
  };

  useEffect(() => {
    const validate = async () => {
      const isExternalLinkValid = channelData.externalLinks?.some(link => link.value.trim() !== "");
      try {
        await schema.validate(channelData, { abortEarly: false });
        channelData.language !== "None" && channelData.country !== "None" && channelData.age && isExternalLinkValid
          ? setIsValidForm(true)
          : setIsValidForm(false);
      } catch (err) {
        let error = err as Yup.ValidationError;
        // setErrors(prev => ({ ...prev, [name]: error.message }));
        setIsValidForm(false);
        if (error.inner) {
          const errors: { path: string; message: string }[] = error.inner.map(error1 => ({
            path: error1.path || "unknown", // Field with the error
            message: error1.message, // Error message
          }));

          console.log("Validation errors:", errors);
        }
      }
    };
    validate();
  }, [channelData, schema]);

  const onChange = async (event: React.FocusEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    updateChannelData(prev => ({ ...prev, description: value }));
    const isValid = await validateForm(name, value);
    const isValid2 = await validateForm("name", channelData.name ?? "");
    setIsEnabled(isValid && isValid2);
  };

  const handleImageChange = (index: number, fileUrl: string | null) => {
    updateChannelData(prev => ({ ...prev, profileImageUrl: fileUrl! }));
  };

  const handleBanerImage = (index: number, fileUrl: string | null) => {
    updateChannelData(prev => ({ ...prev, backgroundImageUrl: fileUrl! }));
  };

  const handlePromoImage = (index: number, fileUrl: string | null) => {
    updateChannelData(prev => ({ ...prev, promoMediaURL: fileUrl! }));
  };

  const resizeImage = (src: string, width: number, height: number, callback: (resizedDataUrl: string) => void) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.drawImage(img, 0, 0, width, height);
        const resizedDataUrl = canvas.toDataURL("image/jpeg");
        callback(resizedDataUrl);
      }
    };
    img.src = src;
  };

  useEffect(() => {
    if (channelData.externalLinks) return;
    const links = [
      { type: "web_social", value: "" },
      { type: "optional", value: "" },
      { type: "optional", value: "" },
    ];
    updateChannelData(prev => ({
      ...prev,
      externalLinks: links,
    }));
  }, [channelData]);

  useEffect(() => {
    updateChannelData(prev => ({
      ...prev,
      secondLanguage: prev.secondLanguage || "optional",
    }));
  }, []);

  // const schema = Yup.object()
  //   .shape({
  //     language: Yup.string().required(`Primary Language is required!`),
  //     secondLanguage: Yup.string()
  //       .oneOf(
  //         [...iso6392.slice(120, 150).map((lang) => lang.iso6392B), "None"],
  //         "Invalid Secondary Language"
  //       )
  //       .notRequired(),
  //     country: Yup.string().required(`Country is required!`),
  //     primaryExternalLink: Yup.string().nullable(),
  //     secondaryExternalLink: Yup.string().nullable(),
  //     otherExternalLink: Yup.string().nullable(),
  //   })
  //   .test(
  //     "at-least-one-external-link",
  //     "At least one external link value is required.",
  //     (values) => {
  //       return Boolean(
  //         values.primaryExternalLink ||
  //           values.secondaryExternalLink ||
  //           values.otherExternalLink
  //       );
  //     }
  //   )
  //   .test(
  //     "at-least-one-url",
  //     "At least one URL must be provided and valid",
  //     (values) => {
  //       return !!(
  //         values.primaryExternalLink ||
  //         values.secondaryExternalLink ||
  //         values.otherExternalLink
  //       );
  //     }
  //   );

  // useEffect(() => {
  //   const validateAll = async () => {
  //     const data = {
  //       language: channelData.language,
  //       secondLanguage: channelData.secondLanguage,
  //       country: channelData.country,
  //       primaryExternalLink: (channelData.externalLinks && channelData.externalLinks[0]?.value) || "",
  //       secondaryExternalLink: (channelData.externalLinks && channelData.externalLinks[1]?.value) || "",
  //       otherExternalLink: (channelData.externalLinks && channelData.externalLinks[2]?.value) || "",
  //     };
  //     try {
  //       await schema.validate(data, { abortEarly: false });
  //       //setEnabled(true);
  //     } catch (error) {
  //       //setEnabled(false);
  //     }
  //   };

  //   validateAll();
  // }, [channelData, schema]);

  // const isoLanguages = [
  //   { title: "English", value: "eng" },
  //   ...iso6392
  //     .filter((lang) => lang.iso6392B !== "eng")
  //     .map((lang) => ({
  //       title: lang.name,
  //       value: lang.iso6392B,
  //     }))
  //     .sort((a, b) => a.title.localeCompare(b.title)),
  // ];

  const isoLanguages = [
    { title: "English", value: "eng" },
    ...iso6392
      .filter(lang => List_of_languages_to_be_displayed.includes(lang.name))
      .map(lang => ({
        title: lang.name,
        value: lang.iso6392B,
      }))
      .sort((a, b) => a.title.localeCompare(b.title)),
  ];

  type CustomCountryNames = {
    [key: string]: string;
  };

  const customCountryNames: CustomCountryNames = {
    "Viet Nam": "Vietnam",
    "United Kingdom of Great Britain and Northern Ireland": "United Kingdom",
    Türkiye: "Turkey",
    "Trinidad and Tobago": "Trinidad & Tobago",
    "Tanzania (United Republic of)": "Tanzania",
    "Taiwan (Province of China)": "Taiwan",
    "Saint Lucia": "St. Lucia",
    "Korea (Republic of)": "South Korea",
    Netherlands: "Netherlands",
    "Republic of Moldova": "Moldova",
    Macao: "Macao SAR China",
    "Lao People's Democratic Republic": "Laos",
    Czechia: "Czech Republic",
    //"Côte d’Ivoire": "Côte d’Ivoire",
    "Brunei Darussalam": "Brunei",
    "Bosnia and Herzegovina": "Bosnia & Herzegovina",
    "Bolivia (Plurinational State of)": "Bolivia",
    "Antigua and Barbuda": "Antigua & Barbuda",
    Bolivia: "Bolivia",
    "Côte d’Ivoire": "Côte d'Ivoire",
    Moldova: "Moldova",
    "South Korea": "South Korea",
    Taiwan: "Taiwan",
    Tanzania: "Tanzania",
  };

  const isoCountries = [
    { title: "United States", value: "USA" },
    ...iso31661
      .filter(country => List_of_countries_to_be_displayed.includes(country.name))
      .map(country => ({
        title: customCountryNames[country.name] || country.name,
        value: country.alpha3,
      }))
      .sort((a, b) => a.title.localeCompare(b.title)),
  ];

  // const isoCountries = [
  //   { title: "United States", value: "USA" },
  //   ...iso31661
  //     .filter((country) => country.alpha3 !== "USA")
  //     .map((country) => ({ title: country.name, value: country.alpha3 }))
  //     .sort((a, b) => a.title.localeCompare(b.title)),
  // ];

  const updateOption = (e: { target: { name: string; value: string } }) => {
    const { name, value } = e.target;
    updateChannelData(prev => ({ ...prev, ...{ [name]: value } }));
  };

  return (
    <>
      {loading && <APILoader loading={loading} />}
      {(isSubmitted || isLoading) && (
        <PopupSingleButton
          popupContent={{
            title: isLoading ? "Submitting..." : isError ? "Failed to Submit" : "Successfully Submitted ",
            message: isLoading
              ? "Your channel is being submitted for review."
              : isError
              ? "Failed to submit your channel for review. Try again."
              : "Your channel is successfully submitted for review.",
            buttonTitle: "OK",
            status: isLoading ? PopupActionStatus.submitting : isError ? PopupActionStatus.failed : PopupActionStatus.success,
          }}
          onClose={async () => {
            isSubmitted && setIsSubmitted(false);
            if (isError) {
              setIsError(false); // Reset error state when closing the popup
            }
          }}
        />
      )}
      {/* {(isSubmitted || isLoading) && (
        <PopupSingleButtonProps
          popupContent={{
            title: isLoading ? "Submitting..." : "Successfully Submitted ",
            message: isLoading
              ? "Your channel is being submitted for review."
              : "Your channel is successfully submitted for review.",
            buttonTitle: "OK",
            status: isLoading
              ? PopupActionStatus.submitting
              : PopupActionStatus.success,
          }}
          onClose={async () => {
            isSubmitted && setIsSubmitted(false);
          }}
        />
      )} */}

      {actionOnItem?.action && dialogContent ? (
        <ArtifactStateDialog
          action={actionOnItem?.action}
          onClose={() => setActionOnItem(null)}
          onUpdate={async () => {
            const action = actionOnItem?.action;
            const contentId = actionOnItem?.itemid;
            updateStatus && contentId && (await updateStatus(contentId, action));
            setActionOnItem(null);
          }}
          dialogeContent={dialogContent}
        />
      ) : (
        <></>
      )}
      <div className="flex flex-col gap-[30px] channel-page-context">
        {channelData.id && !(channelData.status === ChannelState.DRAFT && channelData.subStatus === ChannelSubstate.NONE) ? (
          <HistoryNavigator title="Channel Status" docId={channelData.id} />
        ) : (
          ""
        )}
        <div className="flex flex-col space-y-[10px] w-full">
          <div className="flex items-center">
            <AddTextField
              name={"name"}
              title={"Channel Name"}
              note={"This is the public name of your channel."}
              placeholder={"Name"}
              index={1}
              charAllowed={30}
              value={channelData.name}
              isCloseBtn={false}
              onChange={async e => {
                updateChannelData({ ...channelData, name: e.target.value });
                const { name, value } = e.target;
                const isValid = await validateForm(name, value);
                const isValid2 = await validateForm("description", channelData.description ?? "");
                setIsEnabled(isValid && isValid2);
              }}
              onFocus={e => setInputFocused({ [e.target.name]: true })}
              onBlur={e => setInputFocused({ [e.target.name]: false })}
              notesclass="notes_inner_page"
              disabled={channelData.status !== ChannelState.DRAFT}
              error={touched.name && errors.name ? errors.name : undefined}
            />
          </div>
        </div>
        <div className="flex flex-col space-y-[10px] w-full">
          <div className="relative w-full min-w-[200px] mb-2">
            <AddTextAreaField
              index={2}
              name={"description"}
              title={"Channel Description"}
              note={"Share a brief description about your channel and content."}
              placeholder={"Enter Description"}
              height={150}
              charAllowed={500}
              value={channelData.description as string}
              onChange={onChange}
              // notesclass="notes_inner_page"
              disabled={channelData.status !== ChannelState.DRAFT}
            />
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div>
            <div className="flex items-center">
              <span>
                <span className="content_count">3</span>
              </span>
              <span className="content_title">Channel Profile Photo</span>
            </div>
            <div>
              <label className="notes_inner_page">Recommended resolution 360 x 360.</label>
            </div>

            <div className="mt-[15px] rounded-[12px]">
              <ImageInput
                index={3}
                onFileChange={handleImageChange}
                docId={channelData.id!}
                folder={FolderName.channel}
                maxFileSize={1}
                fileTypeShow="JPG, PNG, or HEIF"
                imageUrl={channelData.profileImageUrl}
                imageWidth={180}
                imageHeight={180}
                editable={channelData.status === ChannelState.DRAFT}
              />
            </div>
            {errors.profileImageUrl && <span className="remaining-characters">{errors.profileImageUrl}</span>}
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div className="flex items-center">
            <span>
              <span className="content_count">4</span>
            </span>
            <span className="content_title">Channel Background Photo</span>
          </div>
          <div>
            <label className="notes_inner_page">Recommended resolution 780 x 260.</label>
          </div>
          <div className="mt-[15px] rounded-[12px]">
            <ImageInput
              index={4}
              onFileChange={handleBanerImage}
              docId={channelData.id!}
              folder={FolderName.channel}
              maxFileSize={1}
              imageUrl={channelData.backgroundImageUrl}
              fileTypeShow="JPG, PNG, or HEIF"
              imageWidth={450}
              imageHeight={150}
              editable={channelData.status === ChannelState.DRAFT}
            />
          </div>
          {errors.backgroundImageUrl && <span className="remaining-characters">{errors.backgroundImageUrl}</span>}
        </div>
        <div className="flex flex-col w-full">
          <div className="flex items-center">
            <span>
              <span className="content_count">5</span>
            </span>
            <span className="content_title">Add Promotional Photo</span>
          </div>
          <div>
            <label className="notes_inner_page">
              We may show this photo on your subscription paywall and in key promotional areas. Recommended aspect ratio of photo is either 4:3, 1:1,
              or 3:4.
            </label>
          </div>
          <div className="mt-[15px] rounded-[12px]">
            <ImageInput
              index={5}
              onFileChange={handlePromoImage}
              docId={channelData.id!}
              folder={FolderName.channel}
              maxFileSize={1}
              fileTypeShow="JPG, PNG, or HEIF"
              imageUrl={channelData.promoMediaURL}
              imageWidth={180}
              imageHeight={180}
              editable={channelData.status === ChannelState.DRAFT}
            />
          </div>
          {errors.promoMediaURL && <span className="remaining-characters">{errors.promoMediaURL}</span>}
        </div>
        <div className="items-center lex">
          <div className="flex items-center">
            <SKSelectOption
              index={6}
              name="language"
              value={channelData.language}
              heading="Channel Languages"
              subHeading={"Choose the primary language of your channel. You can still post in other languages."}
              width={"w-[290px]"}
              options={isoLanguages}
              onUpdate={e => updateOption(e)}
              marginBottom="mb-[15px]"
              editable={channelData.status === ChannelState.DRAFT}
            />
          </div>

          <div className="flex items-center">
            <SKSelectOption
              name="secondLanguage"
              value={channelData.secondLanguage || "optional"}
              heading=""
              subHeading={"Choose the secondary language of your channel if applicable."}
              width={"w-[290px]"}
              options={[{ title: "Optional", value: "optional" }, ...isoLanguages]}
              onUpdate={e => updateOption(e)}
              marginBottom="mb-[0px]"
              editable={channelData.status === ChannelState.DRAFT}
            />
          </div>
        </div>

        <div className="flex items-center">
          <SKSelectOption
            index={7}
            value={channelData.country}
            name="country"
            heading="Channel's Home Country"
            subHeading={"Choose the the home country where you channel is based."}
            width={"w-[290px]"}
            options={isoCountries}
            onUpdate={e => updateOption(e)}
            marginBottom="mb-[0px]"
            editable={channelData.status === ChannelState.DRAFT}
          />
        </div>
        <div className="flex flex-col gap-[10px]">
          <div className="flex flex-col w-full">
            <div className="relative inline-block w-full text-left">
              <SKSelectOption
                id="Link_1"
                index={8}
                value={channelData.externalLinks?.[0]?.type || "web_social"}
                heading="External Links"
                subHeading="Choose important external links you would like your followers to have access to."
                width="w-[290px]"
                options={[{ title: "Website", value: "web_social" }, ...sortedExternalLinkOptions]}
                //options={sortedExternalLinkOptions}
                selectedIndex={1}
                onUpdate={e => {
                  const { value } = e.target;
                  let externalLinks = channelData.externalLinks || [];
                  externalLinks[0] = {
                    type: value,
                    value: externalLinks[0]?.value || "",
                  };
                  updateChannelData(prev => ({ ...prev, externalLinks }));
                }}
                marginBottom="mb-[15px]"
                editable={channelData.status === ChannelState.DRAFT}
              />
            </div>
            <div className="flex items-center">
              <AddTextField
                id={"primaryExternalLink"}
                name={"primaryExternalLink"}
                title={""}
                note={""}
                placeholder={"Add Link"}
                charAllowed={50}
                value={channelData.externalLinks ? channelData.externalLinks?.[0]?.value ?? "" : ""}
                isCloseBtn={false}
                onChange={async e => {
                  const { name, value } = e.target;
                  let externalLinks = channelData.externalLinks;
                  if (externalLinks && externalLinks.length >= 1) {
                    externalLinks[0] = {
                      type: externalLinks[0].type,
                      value: value,
                    };
                  }
                  updateChannelData(prev => ({
                    ...prev,
                    externalLinks,
                  }));
                  await validateForm("externalLinks", externalLinks);
                }}
                showRemainingChar={false}
                disabled={channelData.status !== ChannelState.DRAFT}
              />
            </div>

            {errors.primaryExternalLink && <span className="remaining-characters">{errors.primaryExternalLink}</span>}
          </div>
          <div className="flex flex-col w-full">
            <div className="relative inline-block w-8/12 text-left">
              <SKSelectOption
                id="Link_2"
                value={channelData.externalLinks?.[1]?.type || "optional"}
                selectedIndex={2}
                heading=""
                subHeading={""}
                width={"w-[290px]"}
                options={[{ title: "Optional", value: "optional" }, ...sortedExternalLinkOptions]}
                // onUpdate1={e => {
                //   const { name, value } = e.target;
                //   let externalLinks = channelData.externalLinks;
                //   if (externalLinks && externalLinks.length >= 2) {
                //     externalLinks[1] = {
                //       type: value,
                //       value: externalLinks[1]?.value ?? "",
                //     };
                //   } else {
                //     externalLinks?.push({ type: value, value: "" });
                //   }
                //   updateChannelData(prev => ({
                //     ...prev,
                //     externalLinks,
                //   }));
                // }}
                onUpdate={e => {
                  const { name, value } = e.target;
                  let externalLinks = channelData.externalLinks ? [...channelData.externalLinks] : [];

                  if (externalLinks.length >= 2) {
                    externalLinks[1] = {
                      type: value,
                      value: externalLinks[1]?.value ?? "",
                    };
                  } else {
                    // if externalLinks[2] doesn't exist, fill gaps
                    while (externalLinks.length < 2) {
                      externalLinks.push({ type: "optional", value: "" });
                    }
                    externalLinks.push({ type: value, value: "" });
                  }

                  updateChannelData(prev => ({
                    ...prev,
                    externalLinks,
                  }));
                }}
                marginBottom="mb-[15px]"
                editable={channelData.status === ChannelState.DRAFT}
              />
            </div>

            <div className="flex items-center">
              <AddTextField
                id={"secondaryExternalLink"}
                name={"secondaryExternalLink"}
                title={""}
                note={""}
                placeholder={"Add Link"}
                charAllowed={50}
                value={channelData.externalLinks?.[1]?.value ?? ""}
                isCloseBtn={false}
                onChange={async e => {
                  const { name, value } = e.target;
                  let externalLinks = channelData.externalLinks ? [...channelData.externalLinks] : [];

                  if (externalLinks.length >= 2) {
                    externalLinks[1] = {
                      type: externalLinks[1]?.type ?? "optional",
                      value,
                    };
                  } else {
                    // fill gaps if needed
                    while (externalLinks.length < 2) {
                      externalLinks.push({ type: "optional", value: "" });
                    }
                    externalLinks.push({ type: "optional", value });
                  }

                  updateChannelData(prev => ({
                    ...prev,
                    externalLinks,
                  }));

                  await validateForm("externalLinks", externalLinks);
                }}
                showRemainingChar={false}
                disabled={channelData.status !== ChannelState.DRAFT}
              />
            </div>

            {/* {errors.secondaryExternalLink && <span className="block text-sm text-red-600 dark:text-red-500">{errors.secondaryExternalLink}</span>} */}
          </div>
          <div className="flex flex-col w-full">
            <div className="relative inline-block w-8/12 text-left">
              <SKSelectOption
                id="Link_3"
                value={channelData.externalLinks?.[2]?.type ?? "optional"}
                selectedIndex={3}
                heading=""
                subHeading={""}
                width={"w-[290px]"}
                options={[{ title: "Optional", value: "optional" }, ...sortedExternalLinkOptions]}
                // onUpdate1={e => {
                //   const { name, value } = e.target;
                //   let externalLinks = channelData.externalLinks;
                //   if (externalLinks && externalLinks?.length >= 3) {
                //     externalLinks[2] = {
                //       type: value,
                //       value: externalLinks[2].value,
                //     };
                //   } else {
                //     externalLinks?.push({ type: value, value: "" });
                //   }
                //   updateChannelData(prev => ({
                //     ...prev,
                //     externalLinks,
                //   }));
                // }}
                onUpdate={e => {
                  const { name, value } = e.target;
                  let externalLinks = channelData.externalLinks ? [...channelData.externalLinks] : [];

                  if (externalLinks.length >= 3) {
                    externalLinks[2] = {
                      type: value,
                      value: externalLinks[2]?.value ?? "",
                    };
                  } else {
                    // if externalLinks[2] doesn't exist, fill gaps
                    while (externalLinks.length < 2) {
                      externalLinks.push({ type: "optional", value: "" });
                    }
                    externalLinks.push({ type: value, value: "" });
                  }

                  updateChannelData(prev => ({
                    ...prev,
                    externalLinks,
                  }));
                }}
                marginBottom="mb-[15px]"
                editable={channelData.status === ChannelState.DRAFT}
              />
            </div>

            <div className="flex items-center">
              <AddTextField
                id={"otherExternalLink"}
                name={"otherExternalLink"}
                title={""}
                note={""}
                placeholder={"Add Link"}
                charAllowed={50}
                value={channelData.externalLinks?.[2]?.value ?? "optional"}
                isCloseBtn={false}
                onChange={async e => {
                  const { name, value } = e.target;
                  let externalLinks = channelData.externalLinks ? [...channelData.externalLinks] : [];

                  if (externalLinks.length >= 3) {
                    externalLinks[2] = {
                      type: externalLinks[2]?.type ?? "optional",
                      value,
                    };
                  } else {
                    // fill gaps if needed
                    while (externalLinks.length < 2) {
                      externalLinks.push({ type: "optional", value: "" });
                    }
                    externalLinks.push({ type: "optional", value });
                  }

                  updateChannelData(prev => ({
                    ...prev,
                    externalLinks,
                  }));

                  await validateForm("externalLinks", externalLinks);
                }}
                showRemainingChar={false}
                disabled={channelData.status !== ChannelState.DRAFT}
              />
            </div>

            {/* {errors.otherExternalLink && <span className="remaining-characters">{errors.otherExternalLink}</span>} */}
          </div>
        </div>
        <ChannelCheckListCard
          index={9}
          title="Topic"
          purposeText="Add Topic"
          notes="Topic that represents the primary focus of channel content."
          doneText={channelData.topic ? capitalizeFirstLetter(TopicTypeString[channelData.topic]) : undefined}
          action={() => {
            navigate("../topic");
          }}
          disabled={channelData.status !== ChannelState.DRAFT}
        />
        <ChannelCheckListCard
          index={10}
          title="Age Rating"
          purposeText="Add Age Rating"
          notes="Safety age rating for children."
          doneText={channelData.age ? "Age " + channelData.age + "+" : undefined}
          action={() => {
            navigate("../age");
          }}
          disabled={channelData.status !== ChannelState.DRAFT}
        />
        <ChannelCheckListCard
          index={11}
          title="Channel Safety"
          purposeText="Certify Content"
          notes="Certify that your content is safe and follows Skarvo Content Guidelines."
          doneText={channelData.certifyFirst && channelData.certifySecond ? "Certified" : undefined}
          action={() => {
            navigate("../certification");
          }}
          disabled={channelData.status !== ChannelState.DRAFT}
        />
        <ChannelSubscriptionType
          index={12}
          disabled={channelData.status !== ChannelState.DRAFT}
          channelData={channelData}
          updateChannelData={updateChannelData}
        />
        {(channelData.subscriptionStatus === Tier.paid || channelData.subscriptionStatus === Tier.freeNpaid) && (
          <>
            <AddTextField
              index={13}
              id={"expectedMonthlySubscriptionPrice"}
              name={"expectedMonthlySubscriptionPrice"}
              title={"Monthly Price in USD"}
              note={"This is what subscribers will pay each month to access your paid content."}
              footNote="Enter a valid amount using numbers and a decimal (e.g. 1.99)."
              placeholder={"Expected monthly amount"}
              charAllowed={50}
              value={channelData.expectedMonthlySubscriptionPrice ?? ""}
              isCloseBtn={false}
              onChange={async e => {
                const { value } = e.target;
                updateChannelData &&
                  updateChannelData(prev => ({
                    ...prev,
                    expectedMonthlySubscriptionPrice: value,
                  }));
              }}
              showRemainingChar={false}
              error={errors.expectedMonthlySubscriptionPrice}
              disabled={channelData.status !== ChannelState.DRAFT}
            />

            <AddTextField
              index={14}
              id={"expectedYearlySubscriptionPrice"}
              name={"expectedYearlySubscriptionPrice"}
              title={"Yearly Price in USD"}
              note={"This is what subscribers will pay each year to access your paid content."}
              footNote="Enter a valid amount using numbers and a decimal (e.g. 1.99)."
              placeholder={"Expected monthly amount"}
              charAllowed={50}
              value={channelData.expectedYearlySubscriptionPrice ?? ""}
              isCloseBtn={false}
              onChange={async e => {
                const { value } = e.target;
                updateChannelData &&
                  updateChannelData(prev => ({
                    ...prev,
                    expectedYearlySubscriptionPrice: value,
                  }));
              }}
              showRemainingChar={false}
              error={errors.expectedYearlySubscriptionPrice}
              disabled={channelData.status !== ChannelState.DRAFT}
            />
            <OptionSelect
              index={15}
              title="Adjust Prices by Country"
              subTitle="Make your content more affordable for global audiences."
              value={channelData.adjustSubscriptionPriceByCountry ?? false}
              options={[
                { id: 1, title: "Yes", value: true, description: "Adjust prices by country’s pruchasing power." },
                { id: 2, title: "No", value: false, description: "Prices will remain the same worldwide, based on the USD amounts you set." },
              ]}
              onSelect={val => {
                const adjustSubscriptionPriceByCountry: boolean = (val as boolean) ?? false;
                updateChannelData &&
                  updateChannelData(prev => ({
                    ...prev,
                    adjustSubscriptionPriceByCountry,
                  }));
              }}
              error={errors.adjustSubscriptionPriceByCountry}
              disabled={channelData.status !== ChannelState.DRAFT}
            />
          </>
        )}
      </div>
    </>
  );
}
